import { DateTime, Zone } from 'luxon';

/**
 * @deprecated Use parseDateTime from '@lane-next/async-timing' instead.
 * This function will be removed in a future version.
 */
export default function parseDateTime(
  date: string | number | Date | DateTime | null | undefined,
  timeZone?: string | Zone
): DateTime | null {
  if (!date) {
    return null;
  }

  let ret;

  if (date instanceof Date && Number.isNaN(date.getTime())) {
    // If the date is an invalid Date object, return now
    ret = DateTime.now();
  } else if (typeof date === 'string') {
    ret = DateTime.fromISO(date);
  } else if (typeof date === 'number') {
    ret = DateTime.fromMillis(date);
  } else if (DateTime.isDateTime(date)) {
    ret = date;
  } else if (date.constructor === Date) {
    ret = DateTime.fromJSDate(date);
  } else if (date instanceof Date) {
    ret = DateTime.fromJSDate(date);
  }

  if (!ret) {
    return null;
  }

  if (timeZone && ret.setZone(timeZone).isValid) {
    ret = ret.setZone(timeZone);
  }

  return ret;
}
